import { forwardRef, type Ref, type SVGProps } from "react";
const IconWhatsAppSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="m2.09 30 2-7.18a13.85 13.85 0 1 1 12 6.94 13.8 13.8 0 0 1-6.62-1.69zm7.68-4.44.42.25a11.53 11.53 0 0 0 5.86 1.61A11.52 11.52 0 1 0 6.3 22l.28.44-1.17 4.25z" />
    <path d="M12.59 10.09c-.28-.68-.56-.59-.77-.6h-.67a1.3 1.3 0 0 0-.92.43A3.9 3.9 0 0 0 9 12.8a6.7 6.7 0 0 0 1.41 3.58 15.4 15.4 0 0 0 5.91 5.23 20 20 0 0 0 2 .72 4.6 4.6 0 0 0 2.18.14 3.55 3.55 0 0 0 2.33-1.64 2.9 2.9 0 0 0 .17-1.65c-.09-.14-.32-.23-.67-.4s-2.05-1-2.36-1.13-.55-.17-.78.17-.9 1.13-1.1 1.36-.4.26-.75.09a9.5 9.5 0 0 1-2.78-1.72 10.4 10.4 0 0 1-1.93-2.4c-.2-.34 0-.53.15-.7l.52-.61a2.3 2.3 0 0 0 .35-.58.64.64 0 0 0 0-.6z" />
  </svg>
);
const ForwardRef = forwardRef(IconWhatsAppSVG);
ForwardRef.displayName = "IconWhatsApp";
export { ForwardRef as IconWhatsApp };
